import { ReactComponent as CloseDialog } from 'assett/icons/close_dialog_icon.svg';
import { resetPrescriptionSelectedFromStorage } from 'feature/claims/claimSlice';
import { deleteDocument } from 'feature/upload/uploadSlice';
import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'store/store';
import { Box, Button, Dialog, IconButton, Typography } from 'styles';
import { DocType, IUploadedFileResponse } from 'types/Upload';
import { useTranslation } from 'utils/translations';

type Props = {
	documentType: DocType;
	data?: IUploadedFileResponse;
	openDialog: boolean;
	setOpenDialog: (open: boolean) => void;
};

const DeletePopup: FC<Props> = ({
	documentType,
	data,
	openDialog,
	setOpenDialog,
}) => {
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: 'clientLabels',
	});
	const dispatch = useDispatch<AppDispatch>();

	const { prescriptionSelectedFromStorage } = useSelector(
		(state: RootState) => state.claim,
	);

	const documentUuid = data?.uuid;
	const fileName = data?.fileName;
	const isPrescriptionFromStorage =
		documentType === 'prescription' && prescriptionSelectedFromStorage;

	const onDelete = () => {
		if (!documentUuid) return;

		if (isPrescriptionFromStorage) {
			dispatch(resetPrescriptionSelectedFromStorage());
			setOpenDialog(false);
			return;
		}

		dispatch(deleteDocument({ uuid: documentUuid, docType: documentType }));
		setOpenDialog(false);
	};

	return (
		<Dialog
			title={tClientLabels(`dialog.confirm.deleteUploadedFile.${documentType}`)}
			close={
				<IconButton onClick={() => setOpenDialog(false)}>
					<CloseDialog />
				</IconButton>
			}
			open={openDialog}
			variant="confirm"
			events
			actions={
				<>
					<Button variant="outlined" onClick={() => setOpenDialog(false)}>
						{tClientLabels(`dialog.buttons.cancel`)}
					</Button>
					<Button onClick={onDelete} variant="contained">
						{tClientLabels(`dialog.buttons.continue`)}
					</Button>
				</>
			}
			type=""
		>
			<Box display="flex" gap="1rem" flexDirection="column">
				<Typography variant="body">
					{isPrescriptionFromStorage ? (
						<>
							{tClientLabels(
								'dialog.confirm.deleteUploadedFile.content.prescriptionFromStorage',
								{
									docName: fileName ? fileName : '',
								},
							)}
						</>
					) : (
						<>
							{tClientLabels('dialog.confirm.deleteUploadedFile.content', {
								docName: fileName ? fileName : '',
							})}
						</>
					)}
				</Typography>
			</Box>
		</Dialog>
	);
};

export default DeletePopup;
